import { useContext } from "react";
import { SettingsContext } from "../App";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Calculator from "../components/Calculator";
import Trust from "../components/Trust";
import CollectionBanner from "../components/CollectionBanner";
import Evolution from "../components/Evolution";
import Testimonials from "../components/Testimonials";
import DownloadApp from "../components/DownloadApp";
import Contact from "../components/Contact";
import Reveal from "../components/Reveal";

const METHODS_IMG =
  "https://images.unsplash.com/photo-1762463176417-2c5e63767bd2?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";

export default function Home() {
  const settings = useContext(SettingsContext);
  return (
    <main>
      <Hero settings={settings} />
      <Marquee />

      <section id="calculateur" className="mx-auto max-w-7xl px-5 sm:px-8 pt-24" data-testid="calculator-section">
        <Reveal>
          <Calculator settings={settings} />
        </Reveal>
      </section>

      <Trust />
      <CollectionBanner />
      <Evolution />
      <Testimonials />
      <DownloadApp settings={settings} />

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pb-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-gold/15" data-testid="methods-band">
            <img src={METHODS_IMG} alt="Nos méthodes de test" className="absolute inset-0 w-full h-full object-cover opacity-25" />
            <div className="relative bg-gradient-to-r from-ink/90 via-ink/70 to-transparent p-8 sm:p-14">
              <p className="text-xs tracking-[0.35em] uppercase text-gold">Nos méthodes de test</p>
              <p className="mt-4 font-display text-2xl sm:text-3xl text-cream max-w-xl leading-snug">
                Poinçons, pierre de touche, analyse XRF sans dommage et pesée sur balance certifiée.
              </p>
            </div>
          </div>
        </Reveal>
      </section>

      <Contact settings={settings} />
    </main>
  );
}
